import { useEffect, useState } from "react";
import { getAnnouncements } from "../../firebase/services";
import { EmptyState, Spinner } from "../../components/UI";

const CATEGORIES = {
  info:        { label: "Information",  icon: "ℹ️",  color: "#1a3a5c", bg: "#e3f1fb" },
  urgent:      { label: "Urgent",       icon: "🚨",  color: "#a32d2d", bg: "#fdecea" },
  maintenance: { label: "Maintenance",  icon: "🔧",  color: "#8a4c00", bg: "#fff3e0" },
  event:       { label: "Événement",    icon: "🎉",  color: "#2d6a0a", bg: "#e8f5e0" },
};

function timeAgo(ts) {
  if (!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  const s = (Date.now() - d.getTime()) / 1000;
  if (s < 3600) return `il y a ${Math.round(s/60)} min`;
  if (s < 86400) return `il y a ${Math.round(s/3600)}h`;
  return `il y a ${Math.round(s/86400)}j`;
}

export default function StudentAnnouncements({ roomId, onBack }) {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading]             = useState(true);

  useEffect(() => {
    const unsub = getAnnouncements(data => {
      // Afficher les annonces globales + celles pour cette chambre
      const filtered = data.filter(a => !a.targetRoomId || a.targetRoomId === roomId);
      setAnnouncements(filtered);
      setLoading(false);
    });
    return unsub;
  }, [roomId]);

  if (loading) return <div style={S.page}><Spinner /></div>;

  return (
    <div style={S.page}>
      <div style={S.header}>
        {onBack && <button style={S.back} onClick={onBack}>←</button>}
        <span style={S.htitle}>Annonces IAM</span>
      </div>

      <div style={S.scroll}>
        {announcements.length === 0 ? (
          <EmptyState icon="📢" title="Aucune annonce" subtitle="Les annonces de IAM Business Group apparaîtront ici" />
        ) : announcements.map(a => {
          const cat = CATEGORIES[a.category] || CATEGORIES.info;
          return (
            <div key={a.id} style={{ ...S.card, borderLeft: `4px solid ${cat.color}` }}>
              <div style={S.cardTop}>
                <div style={{ ...S.catBadge, background: cat.bg, color: cat.color }}>
                  {cat.icon} {cat.label}
                </div>
                <span style={S.time}>{timeAgo(a.createdAt)}</span>
              </div>
              <p style={S.cardTitle}>{a.title}</p>
              <p style={S.cardBody}>{a.body}</p>
              <div style={S.footer}>
                <span style={S.from}>📌 IAM Business Group</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const S = {
  page:    { display: "flex", flexDirection: "column", height: "100%", background: "#f5f8fc", fontFamily: "'Barlow',sans-serif" },
  header:  { background: "#1a3a5c", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10 },
  back:    { background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer", padding: "0 8px 0 0" },
  htitle:  { fontSize: 15, fontWeight: 700, color: "white" },
  scroll:  { flex: 1, overflowY: "auto", padding: "12px 16px 80px" },
  card:    { background: "white", borderRadius: "0 14px 14px 0", padding: "14px", marginBottom: 10, borderTop: "0.5px solid #d0dce8", borderRight: "0.5px solid #d0dce8", borderBottom: "0.5px solid #d0dce8" },
  cardTop: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 },
  catBadge:{ fontSize: 11, fontWeight: 700, borderRadius: 20, padding: "3px 10px" },
  time:    { fontSize: 11, color: "#aab8c8" },
  cardTitle:{ fontSize: 15, fontWeight: 700, color: "#1a2a3a", margin: "0 0 6px" },
  cardBody: { fontSize: 13, color: "#4a6a8a", lineHeight: 1.6, margin: "0 0 8px" },
  footer:  { display: "flex", justifyContent: "flex-end" },
  from:    { fontSize: 11, color: "#aab8c8" },
};
